// extracted by mini-css-extract-plugin
export default {"offlineAlert":"UserHeaderMobile_offlineAlert__zzagx","hideAnimation":"UserHeaderMobile_hideAnimation__LNxHG"};